import React, { Component } from 'react';
import { Tag, Dropdown, Icon, Menu, message } from 'antd';
import Configuration from '../../Configuration';
import axios from 'axios';

class VisitCarrier extends Component {
  constructor(props) {
    super(props);
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {};
    this.changeStatus = this.changeStatus.bind(this);
    this.getStatusMenu = this.getStatusMenu.bind(this);
  }

  changeStatus(id, status) {
    axios.put(`${Configuration.apiServer}/api/v1/visits/${id}/status`, {visit: {status: status}}, {headers: this.headers}).then(resp => {
      if(resp.data.status === 'ok')
        message.success('Visita actualizada');
        this.props.update(id, 'status', status);
    });
  }

  getStatusMenu(visit) {
    if((visit.status === 'pending' && visit.quick) || visit.status === 'authorized') {
      return (
        <Menu>
          <Menu.Item key="statusMenu:access"><span onClick={ () => { this.changeStatus(visit.id, 'access') } }>Dar acceso</span></Menu.Item>
        </Menu>
      );
    } else if(visit.status === 'access' || visit.status === 'reception' || visit.status === 'personal') {
      return (
        <Menu>
          <Menu.Item key="statusMenu:leave"><span onClick={ () => { this.changeStatus(visit.id, 'leave') } }>Dar salida</span></Menu.Item>
        </Menu>
      );
    } else {
      return (
        <Menu> 
          <Menu.Item key="statusMenu:null">Sin opciones</Menu.Item>
        </Menu>
      );
    }
  }

  render() {
    // Render component
    return ( 
      <div className="visits-list-item" style={{ padding: '20px 0px' }} onClick={() => { this.props.handleClick(this.props.visit) }}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-center" style={{ width: '20%' }}>
            <div>
              <img src="http://placehold.it/65x65" className="img-fluid rounded-circle" alt="" />
              <div className="visit-kind-image">
                <img src="imgs/shield.svg" alt="" className="img-fluid" />
              </div>
            </div>
          </div>

          <div className="icon-subject-and-visitor d-flex align-items-start" style={{ width: '30%' }}>
            <div className="d-flex flex-column d-block">
              <span className="text-primary">Visita de transportista</span>
              <span className="text-muted text-capitalize">Conductor {this.props.visit.visit_kind.visit_ticket.driver.name}</span>
              <span className="text-capitalize">{this.props.visit.visit_kind.visit_ticket.carrier.name}</span>
              <span className="text-capitalize">{this.props.visit.visit_kind.visit_ticket.truck_kind.name} [{this.props.visit.visit_kind.visit_ticket.truck.plates}]</span>
            </div>
          </div>

          <p className="text-muted m-0 d-flex flex-column" style={{ width: '30%' }}>
            <span className="d-block text-capitalize">Llegada: {Configuration.formatDatetime(this.props.visit.arrive_date)}</span>
            <span className="d-block">Salida: {Configuration.formatDatetime(this.props.visit.leave_date)}</span>
            <span className="d-block text-info">Permanencia: {Configuration.stayTime(this.props.visit.arrive_date, this.props.visit.leave_date)}</span>
          </p>

          <div className="d-flex flex-column d-block" style={{ width: '20%' }}>
            <span className="d-block text-capitalize">{(this.props.visit.quick) ? 'Visita rápida' : 'Visita Preregistro'}</span>
            <span className="text-muted">
              <Dropdown overlay={this.getStatusMenu(this.props.visit)}>
                <Tag color={Configuration.getVisitStatus(this.props.visit.status).hex}>{Configuration.getVisitStatus(this.props.visit.status).text} <Icon type="down" /></Tag>
              </Dropdown>
            </span>
          </div>

        </div>
      </div>
    )
  }
}

export default VisitCarrier;



// WEBPACK FOOTER //
// ./src/components/access/VisitCarrier.js